module.exports = __webpack_public_path__ + "img/instagram_icon_black.9c1c8e5b.svg";